"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Linkedin = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _core.makeStyles)(function () {
  return {
    root: {
      width: '10px',
      height: '10px'
    }
  };
});

var Linkedin = function Linkedin(props) {
  var classes = useStyles(props);
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    viewBox: "0 0 10 10"
  }, props, {
    classes: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.599854 2.2C0.599854 1.53726 1.13711 1 1.79985 1C2.4626 1 2.99985 1.53726 2.99985 2.2C2.99985 2.86274 2.4626 3.4 1.79985 3.4C1.13711 3.4 0.599854 2.86274 0.599854 2.2ZM2.19985 2.2C2.19985 1.97909 2.02077 1.8 1.79985 1.8C1.57894 1.8 1.39985 1.97909 1.39985 2.2C1.39985 2.42091 1.57894 2.6 1.79985 2.6C2.02077 2.6 2.19985 2.42091 2.19985 2.2ZM6.59985 3.4C5.05346 3.4 3.79985 4.6536 3.79985 6.2V9C3.79985 9.22091 3.97894 9.4 4.19985 9.4H5.79985C6.02077 9.4 6.19985 9.22091 6.19985 9V6.2C6.19985 5.97909 6.37894 5.8 6.59985 5.8C6.82077 5.8 6.99985 5.97909 6.99985 6.2V9C6.99985 9.22091 7.17894 9.4 7.39985 9.4H8.99985C9.22077 9.4 9.39985 9.22091 9.39985 9V6.2C9.39985 4.6536 8.14625 3.4 6.59985 3.4ZM6.68661 4.20185C7.75093 4.24727 8.59985 5.1245 8.59985 6.2V8.6H7.79985V6.2C7.79985 5.53726 7.2626 5 6.59985 5L6.52934 5.00204C5.89942 5.03854 5.39985 5.56093 5.39985 6.2V8.6H4.59985V6.2C4.59985 5.09543 5.49528 4.2 6.59985 4.2L6.68661 4.20185ZM2.59985 3.8H0.999853C0.77894 3.8 0.599854 3.97909 0.599854 4.2V9C0.599854 9.22091 0.77894 9.4 0.999853 9.4H2.59985C2.82077 9.4 2.99985 9.22091 2.99985 9V4.2C2.99985 3.97909 2.82077 3.8 2.59985 3.8ZM2.19985 4.6V8.6H1.39985V4.6H2.19985Z",
    fill: "black"
  }));
};

exports.Linkedin = Linkedin;